import MadameCharpentier from "../images/glossary/DP-35674-madame-charpentier.jpg";
import penitenceOfStJerome from "../images/glossary/DP-437261-penitenceOfStJerome.jpg";
import templeOfVesta from "../images/glossary/DP-342437-templeOfVesta.jpg";
import ballancelle from "../images/glossary/DP-640379-ballancelle.jpg";
import polidoroDaCaravaggio from "../images/glossary/DP-338246-polidoroDaCaravaggio.jpg";
import diversPaysages from "../images/glossary/DP-412723-diversPaysages.jpg";
import miraclesOfTheLoaves from "../images/glossary/DP-437821-miraclesOfTheLoaves.jpg";
import bridgeOverACascade from "../images/glossary/DP-437474-bridgeOverACascade.jpg";
import islandOfSMVenice from "../images/glossary/DP-438117-islandOfSMVenice.jpg";
import banksOfBrittany from "../images/glossary/DP-438677-banksOfBrittany.jpg";
import davidCaveOfAdullam from "../images/glossary/DP-436940-davidCaveOfAdullam.jpg";
import mountainousLandscapeWfall from "../images/glossary/DP-436817-mountainousLandscapeWfall.jpg";
import aqueductInRuins from "../images/glossary/DP-437471-aqueductInRuins.jpg";
import cumPriutlegio from "../images/glossary/DP-397598-cumPriutlegio.jpg";
import warwickCastle from "../images/glossary/DP-438106-warwickCastle.jpg";
import cabbageGatherers from "../images/glossary/DP-437315-cabbageGatherers.jpg";
import madonnaDellaSalute from "../images/glossary/DP-437853-madonnaDellaSalute.jpg";
import cowherdAtValhermeil from "../images/glossary/DP-437300-cowherdAtValhermeil.jpg";
import italianLandscape from "../images/glossary/DP-435973-italianLandscape.jpg";
import canalnVenice from "../images/glossary/DP-437460-canalnVenice.jpg";
import appleBlossoms from "../images/glossary/DP-436085-appleBlossoms.jpg";
import arrivalInBethlehem from "../images/glossary/DP-437010-arrivalInBethlehem.jpg";
import cataniaAndMount from "../images/glossary/DP-436859-cataniaAndMount.jpg";
import montSainteVictoire from "../images/glossary/DP-435878-montSainteVictoire.jpg";
import EdgeofTheWoods from "../images/glossary/DP-437514-EdgeofTheWoods.jpg";
import fortifiedWall from "../images/glossary/DP-438645-fortifiedWall.jpg";
import onTheSeine from "../images/glossary/DP-437461-onTheSeine.jpg";
import pansies from "../images/glossary/DP-437985-pansies.jpg";
import bayOfNaples from "../images/glossary/DP-437427-bayOfNaples.jpg";
import montSainteVictoireAndArcRiver from "../images/glossary/DP-435877-montSainteVictoireAndArcRiver.jpg";
import brazilianLandscape from "../images/glossary/DP-437323-brazilianLandscape.jpg";
import bridgeAtvilleneuve from "../images/glossary/DP-437680-bridgeAtvilleneuve.jpg";
import meadowsInMorning from "../images/glossary/DP-437683-meadowsInMorning.jpg";
import roadInlouveciennes from "../images/glossary/DP-437436-roadInlouveciennes.jpg";
import hillsArround from "../images/glossary/DP-437431-hillsArround.jpg";
import bargesAtpontoise from "../images/glossary/DP-437302-bargesAtpontoise.jpg";
import villageByariver from "../images/glossary/DP-435751-villageByariver.jpg";
import kynance from "../images/glossary/DP-435775-kynance.jpg";
import viewOftheseine from "../images/glossary/DP-437659-viewOftheseine.jpg";

export function randomGlossaryImage() {
  const images = [
    {
      src: MadameCharpentier,
      alt: "Portrait of Madame Charpentier by Pierre-Auguste Renoir",
      link: "https://www.metmuseum.org/art/collection/search/438815",
    },
    {
      src: penitenceOfStJerome,
      alt: "The Penitence of Saint Jerome by Joachim Patinir",
      link: "https://www.metmuseum.org/art/collection/search/437261",
    },
    {
      src: templeOfVesta,
      alt: "View of the Temple of Vesta by Jean Jacques de Boissieu",
      link: "https://www.metmuseum.org/art/collection/search/342437",
    },
    {
      src: ballancelle,
      alt: "Ballancelle (Mediterranean), from the Types of Vessels series (N139) issued by Duke Sons & Co. to promote Honest Long Cut Tobacco",
      link: "https://www.metmuseum.org/art/collection/search/640379",
    },
    {
      src: polidoroDaCaravaggio,
      alt: "Scenes from Ancient History, after Polidoro da Caravaggio by Andrea Boscoli",
      link: "https://www.metmuseum.org/art/collection/search/338246",
    },
    {
      src: diversPaysages,
      alt: 'A waterfall descending from the mountains in the center background, various animals and a woman and child beneath a tree in the foreground, from "Various Landscapes" (Divers Paysages)',
      link: "https://www.metmuseum.org/art/collection/search/412723",
    },
    {
      src: miraclesOfTheLoaves,
      alt: "The Miracle of the Loaves and Fishes by Jacopo Robusti",
      link: "https://www.metmuseum.org/art/collection/search/437821",
    },
    {
      src: bridgeOverACascade,
      alt: "Bridge over a Cascade by Hubert Robert",
      link: "https://www.metmuseum.org/art/collection/search/437474",
    },
    {
      src: islandOfSMVenice,
      alt: "The Island of San Michele, Venice by Francesco Guardi",
      link: "https://www.metmuseum.org/art/collection/search/438117",
    },
    {
      src: banksOfBrittany,
      alt: "The Banks of the Rance, Brittany by Pierre Henri de Valenciennes",
      link: "https://www.metmuseum.org/art/collection/search/438677",
    },
    {
      src: davidCaveOfAdullam,
      alt: "David at the Cave of Adullam by Giovanni Maldura",
      link: "https://www.metmuseum.org/art/collection/search/436940",
    },
    {
      src: mountainousLandscapeWfall,
      alt: "A Mountainous Landscape with a Waterfall by Kerstiaen de Keuninck",
      link: "https://www.metmuseum.org/art/collection/search/436817",
    },
    {
      src: aqueductInRuins,
      alt: "Aqueduct in Ruins by Hubert Robert",
      link: "https://www.metmuseum.org/art/collection/search/437471",
    },
    {
      src: cumPriutlegio,
      alt: 'Plate 5 from "Les Grandes Frises" by Pierre Brebiette',
      link: "https://www.metmuseum.org/art/collection/search/397598",
    },
    {
      src: warwickCastle,
      alt: 'Warwick Castle by Canaletto "Giovanni Antonio Canal" ',
      link: "https://www.metmuseum.org/art/collection/search/438106",
    },
    {
      src: cabbageGatherers,
      alt: "Fan Mount: The Cabbage Gatherers by Camille Pissarro",
      link: "https://www.metmuseum.org/art/collection/search/437315",
    },
    {
      src: madonnaDellaSalute,
      alt: "Venice, from the Porch of Madonna della Salute",
      link: "https://www.metmuseum.org/art/collection/search/437853",
    },
    {
      src: cowherdAtValhermeil,
      alt: "A Cowherd at Valhermeil, Auvers-sur-Oise by Camille Pissarro",
      link: "https://www.metmuseum.org/art/collection/search/437300",
    },
    {
      src: italianLandscape,
      alt: "Italian Landscape by Camille Corot",
      link: "https://www.metmuseum.org/art/collection/search/435973",
    },
    {
      src: canalnVenice,
      alt: "A Canal in Venice by Martin Rico y Ortega",
      link: "https://www.metmuseum.org/art/collection/search/437460",
    },
    {
      src: appleBlossoms,
      alt: "Apple Blossoms by Charles-François Daubigny",
      link: "https://www.metmuseum.org/art/collection/search/436085",
    },
    {
      src: arrivalInBethlehem,
      alt: "The Arrival in Bethlehem by Master of the Brussels Calling of Saint Matthew",
      link: "https://www.metmuseum.org/art/collection/search/437010",
    },
    {
      src: cataniaAndMount,
      alt: "Catania and Mount Etna by Edward Lear",
      link: "https://www.metmuseum.org/art/collection/search/436859",
    },
    {
      src: montSainteVictoire,
      alt: "Mont Sainte-Victoire by Paul Cézanne",
      link: "https://www.metmuseum.org/art/collection/search/435878",
    },
    {
      src: EdgeofTheWoods,
      alt: "The Edge of the Woods at Monts-Girard, Fontainebleau Forest by Théodore Rousseau",
      link: "https://www.metmuseum.org/art/collection/search/437514",
    },
    {
      src: fortifiedWall,
      alt: "Fortified Wall at Tivoli by Simon Denis",
      link: "https://www.metmuseum.org/art/collection/search/438645",
    },
    {
      src: onTheSeine,
      alt: "On the Seine by Martín Rico y Ortega",
      link: "https://www.metmuseum.org/art/collection/search/437461",
    },
    {
      src: pansies,
      alt: "Pansies by Henri Fantin-Latour",
      link: "https://www.metmuseum.org/art/collection/search/437985",
    },
    {
      src: bayOfNaples,
      alt: "The Bay of Naples by Auguste Renoir",
      link: "https://www.metmuseum.org/art/collection/search/437427",
    },
    {
      src: montSainteVictoireAndArcRiver,
      alt: "Mont Sainte-Victoire and the Viaduct of the Arc River Valley by Paul Cézanne",
      link: "https://www.metmuseum.org/art/collection/search/435877",
    },
    {
      src: brazilianLandscape,
      alt: "A Brazilian Landscape by Frans Post",
      link: "https://www.metmuseum.org/art/collection/search/437323",
    },
    {
      src: bridgeAtvilleneuve,
      alt: "The Bridge at Villeneuve-la-Garenne by Alfred Sisley",
      link: "https://www.metmuseum.org/art/collection/search/437680",
    },
    {
      src: meadowsInMorning,
      alt: "TSahurs Meadows in Morning Sun by Alfred Sisley",
      link: "https://www.metmuseum.org/art/collection/search/437683",
    },
    {
      src: roadInlouveciennes,
      alt: "A Road in Louveciennes by Auguste Renoir",
      link: "https://www.metmuseum.org/art/collection/search/437436",
    },
    {
      src: hillsArround,
      alt: "Hills around the Bay of Moulin Huet, Guernsey by Auguste Renoir",
      link: "https://www.metmuseum.org/art/collection/search/437431",
    },
    {
      src: bargesAtpontoise,
      alt: "Barges at Pontoise by Camille Pissarro",
      link: "https://www.metmuseum.org/art/collection/search/437302",
    },
    {
      src: villageByariver,
      alt: "Village by a River by Eugène Boudin",
      link: "https://www.metmuseum.org/art/collection/search/435751",
    },
    {
      src: kynance,
      alt: "Kynance by John Brett",
      link: "https://www.metmuseum.org/art/collection/search/435775",
    },
    {
      src: viewOftheseine,
      alt: "View of the Seine by Georges Seurat",
      link: "https://www.metmuseum.org/art/collection/search/437659",
    },
  ];
  const index = Math.floor(Math.random() * images.length);
  return images[index];
}
